var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSend = function SvgSend(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.239 16.027",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#63849e",
    d: "M17.738 8.014a.28.28 0 0 1-.167.255L.905 15.49a.278.278 0 0 1-.351-.394l3.275-5.682a.28.28 0 0 1 .139-.12l3.286-1.28-3.286-1.286a.28.28 0 0 1-.139-.12L.554.93A.278.278 0 0 1 .905.536l16.666 7.222a.28.28 0 0 1 .167.255Z",
    "data-name": "Pfad 696"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export default ForwardRef;